import { useState } from "#app"

export interface ItemListContextData {
    item_list_id: string
    item_list_name: string
    index: number | string
}

export function useItemListContextStore() {
    const itemListContextData = useState<ItemListContextData | null>('itemListContext', () => null)

    function setItemListContextData(data: ItemListContextData) {
        itemListContextData.value = data
    }

    function clearItemListContextData() {
        itemListContextData.value = null
    }

    return {
        itemListContextData,
        setItemListContextData,
        clearItemListContextData
    }
}
